import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation TableReservationUpdateV2($id: ID!, $input: TableReservationUpdateV2!) {
    updateTableReservationV2(id: $id, input: $input) {
      id
      platformType
      tableId
      guestName
      status
      message
      startTime
      seats
    }
  }
`);

export default function useTableReservationUpdateV2() {
  return useMutation(MUTATION, {
    refetchQueries: ['TableReservationDetail'],
  });
}
